import {
    useEffect,
    useState
} from 'react';

import {

    getNotices,

    insertNotice,

    updateNotice,

    deleteNotice

} from '../../../api/adminApi';

import './AppNoticeManage.css';

interface Notice {

    id: number;

    title: string;

    content: string;

    writerId: number;

    createdAt: string;

    updatedAt: string;
}

const AppNoticeManage = () => {

    const [notices, setNotices] =
        useState<Notice[]>([]);

    const [title, setTitle] =
        useState('');

    const [content, setContent] =
        useState('');

    const [showModal, setShowModal] =
        useState(false);

    const [editItem, setEditItem] =
        useState<Notice | null>(null);

    useEffect(() => {

        loadNotices();

    }, []);

    const loadNotices = async () => {

        const response =
            await getNotices();

        setNotices(
            response.data
        );
    };

    const handleInsert = async () => {

        if (
            !title.trim()
            || !content.trim()
        ) {

            alert(
                '제목과 내용을 입력하세요'
            );

            return;
        }

        await insertNotice({

            title,

            content,

            writerId: 1

        });

        setTitle('');
        setContent('');
        loadNotices();
    };

    const handleEdit = (
        item: Notice
    ) => {

        setEditItem(item);
        setShowModal(true);
    };

    const handleSave = async () => {

        if (!editItem) {

            return;
        }

        await updateNotice(
            editItem.id,
            {

                title:
                editItem.title,

                content:
                editItem.content,

                writerId: 1

            }
        );

        setShowModal(false);
        setEditItem(null);
        loadNotices();
    };

    const handleDelete = async (
        id: number
    ) => {

        if (
            !window.confirm(
                '삭제하시겠습니까?'
            )
        ) {

            return;
        }

        await deleteNotice(id);
        loadNotices();
    };

    return (

        <div className="notice-manage">

            <h2 className="notice-title">
                공지사항 관리
            </h2>

            <div className="notice-form">

                <input
                    className="notice-input"
                    placeholder="제목"
                    value={title}
                    onChange={(e) =>
                        setTitle(
                            e.target
                                .value
                        )
                    }
                />

                <textarea
                    className="notice-textarea"
                    placeholder="내용"
                    value={content}
                    onChange={(e) =>
                        setContent(
                            e.target
                                .value
                        )
                    }
                />

                <button
                    className="notice-save-button"
                    onClick={
                        handleInsert
                    }
                >
                    등록
                </button>

            </div>

            <div className="notice-list">

                {
                    notices.map(
                        (item) => (

                            <div
                                key={
                                    item.id
                                }
                                className="notice-card"
                            >

                                <div
                                    className="notice-header"
                                >

                                    <h4
                                        className="notice-item-title"
                                    >

                                        {
                                            item
                                                .title
                                        }

                                    </h4>

                                    <span
                                        className="notice-date"
                                    >

                                        {item
                                            .createdAt
                                        }

                                    </span>

                                </div>

                                <p
                                    className="notice-content"
                                >

                                    {item
                                        .content
                                    }

                                </p>

                                <div
                                    className="notice-actions"
                                >

                                    <button
                                        className="notice-edit-button"
                                        onClick={() =>
                                            handleEdit(
                                                item
                                            )
                                        }
                                    >
                                        수정
                                    </button>

                                    <button
                                        className="notice-delete-button"
                                        onClick={() =>
                                            handleDelete(
                                                item
                                                    .id
                                            )
                                        }
                                    >
                                        삭제
                                    </button>

                                </div>

                            </div>

                        )
                    )
                }

            </div>

            {
                showModal
                && editItem && (

                    <div
                        className="notice-modal-overlay"
                    >

                        <div
                            className="notice-modal-box"
                        >

                            <h3
                                className="notice-modal-title"
                            >
                                공지 수정
                            </h3>

                            <input
                                className="notice-input"
                                value={
                                    editItem
                                        .title
                                }
                                onChange={(e) =>
                                    setEditItem({

                                        ...editItem,

                                        title:
                                        e.target
                                            .value

                                    })
                                }
                            />

                            <textarea
                                className="notice-textarea"
                                value={
                                    editItem
                                        .content
                                }
                                onChange={(e) =>
                                    setEditItem({

                                        ...editItem,

                                        content:
                                        e.target
                                            .value

                                    })
                                }
                            />

                            <div
                                className="notice-modal-buttons"
                            >

                                <button
                                    className="notice-save-button"
                                    onClick={
                                        handleSave
                                    }
                                >
                                    저장
                                </button>

                                <button
                                    className="notice-cancel-button"
                                    onClick={() => {

                                        setShowModal(
                                            false
                                        );

                                        setEditItem(
                                            null
                                        );

                                    }}
                                >
                                    취소
                                </button>

                            </div>

                        </div>

                    </div>

                )
            }

        </div>
    );
};

export default AppNoticeManage;
